import React from 'react';
import classNames from 'classnames';

import {COMPANY_STATUSES} from 'configs';
import {LabelAddress} from 'components/Labels';
import ContentTable from 'components/Contents/ContentTable';

import useGetLocations from './useGetLocations';
import {useAuth} from 'contexts/AuthContext';

import styles from './styles.module.scss';
import {Container} from 'reactstrap';
import cx from 'classnames';
import {get} from 'lodash';

function ABKeyLocations() {
  const {isAuth, isMainAccount, account} = useAuth();
  const isCompanySuspended =
    get(account, 'account.company.company_status') ===
    COMPANY_STATUSES.suspended;

  const {data, meta, isLoading} = useGetLocations();
  const {total_rows} = meta || {};

  return (
    <section
      className={cx({
        'mb-5': isAuth && isMainAccount ? !isCompanySuspended : false,
      })}
    >
      <h3 className={classNames(styles['section__title'], 'mb-4')}>
        Key Locations {`(${total_rows || 0})`}
      </h3>

      <Container className={styles['table-container']}>
        <ContentTable
          v2
          hover={false}
          className="mb-0"
          minHeight="364px"
          responsive={false}
          isFetching={isLoading}
          head={['Office Type', 'Country', 'Address']}
        >
          {data.map((item, index) => {
            const {office_type, country_name, state, street, postcode, city} =
              item;

            return (
              <tr key={index}>
                <td className="text-secondary">{office_type}</td>
                <td className="text-secondary">{country_name}</td>
                <td className="text-secondary">
                  <LabelAddress
                    street={street}
                    city={city}
                    state={state}
                    postcode={postcode}
                  />
                </td>
              </tr>
            );
          })}
        </ContentTable>
      </Container>
    </section>
  );
}

export default ABKeyLocations;
